import React from 'react'
import PropTypes from 'prop-types'
import { isArray, zipWith } from 'lodash'
import Component from './Component'

export default class AccordionItem extends Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.array
    ]),
    titleClass: PropTypes.array,
    name: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      opened: false,
      class: 'closed'
    }
  }

  get sectionHeadTitleComponents() {
    if (isArray(this.props.title)) {
      return zipWith(this.props.title, this.props.titleClass, (titleText, titleClass) => (
        <div
          className={`accordion-title ${titleClass}`}
          key={`section-head-title_${titleText}`}
        >
          {titleText}
        </div>
      ))
    }
    return <div className={this.props.titleClass}>{this.props.title}</div>
  }

  handleClick = () => {
    this.setState((prevState) => {
      return {
        opened: !prevState.opened,
        class: prevState.opened ? 'closed' : 'opened'
      }
    })
  }

  /* eslint-disable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
  render() {
    const sectionHeadTitles = this.sectionHeadTitleComponents
    return (
      <div className={`accordion-container ${this.state.class}`} name={this.props.name}>
        <div
          className={`accordion-item box box--table box--hover flex-box pointer ${this.state.class}`}
          name={`${this.props.name}-toggle`}
          onClick={this.handleClick}
        >
          {sectionHeadTitles}
        </div>

        {this.state.opened
          && (
            <div className="accordion-content padded">
              {this.props.children}
            </div>
          )}
      </div>
    )
  }
  /* eslint-enable jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
}
